import { render, staticRenderFns } from "./compRebateConfig.vue?vue&type=template&id=795aec03"
import script from "./compRebateConfig.vue?vue&type=script&lang=js"
export * from "./compRebateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports